{value: $__placeholder__0}


/** WEBPACK FOOTER **
 ** ../../../@traceur/generated/TemplateParser/5
 **/